export default {
    current: (state) => {
        return state.start_id
    }
}
